function initializeCarousel() {
  document.querySelectorAll('.press-slider__wrapper')?.forEach((each) => {
    const childCount = each.querySelectorAll('.press-item-content').length;
    const isDesktop = window.innerWidth > 767;
    const threshold = isDesktop ? 4 : 2;

    // Remove existing Flickity instance if it exists
    if (each.flickityInstance) {
      each.flickityInstance.destroy();
      each.flickityInstance = null;
    }

    if (childCount > threshold) {
      // Apply Flickity carousel
      each.flickityInstance = new Flickity(each, {
        cellAlign: "left",
        contain: true,
        pageDots: false,
        groupCells: isDesktop ? 1 : 2,
        prevNextButtons: isDesktop ? true : false,
      });
    }
  });
}

// Initialize carousel on page load
initializeCarousel();

// Reinitialize carousel on window resize
window.addEventListener('resize', initializeCarousel);